module.exports = __webpack_public_path__ + "img/ssyx_16.9db3c8ea.jpg";